export default __webpack_public_path__ + "static/media/cruz.6da3ed48.svg";